import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import * as CaseApi from 'saas/pco/cases/api';
import StudyModal from 'saas/pco/cases-creation/step2/components/StudyModal';
import * as WorkerApi from 'saas/users/api';
import { success, error } from 'plugins/toastr';

export default function bind(id) {
  const $multiButton = $('#bt-schedule-study');
  const root = document.getElementById('modal-root');

  $multiButton.on('click', evt => {
    $multiButton.addClass('loading');

    Promise.all([WorkerApi.getAllWorkers(), CaseApi.getSitesByCase(id)]).then(
      response =>
        displayMultiSiteModal(
          response[1].filter(s => !s.study_id),
          response[0]
        )
    );
  });

  function displayMultiSiteModal(sites, workers) {
    $multiButton.removeClass('loading');

    // Handling cancel button
    const onCancel = () => {
      ReactDOM.unmountComponentAtNode(root);
    };

    const saveStudy = (selectedSites, generalState) => {
      $multiButton.addClass('loading');

      // Serialize form
      const data = new FormData();

      const sitesValue = selectedSites.map(s => s.id).join(',');
      data.append('sites', sitesValue);

      if (generalState && !generalState.workerUnknown && generalState.worker) {
        data.append('worker', generalState.worker);
      }
      if (generalState && !generalState.dateUnknown && generalState.date) {
        data.append('studyDate', generalState.date);
      }

      const hideModal = () => {
        onCancel();
        $multiButton.removeClass('loading');
      };

      // Schedule study
      CaseApi.scheduleStudy(id, data).then(
        _ => {
          hideModal();
          success('Etude planifiée avec succès');
        },
        err => {
          console.log('Error attempting to schedule case study', err);
          hideModal();
          error('Une erreur est survenue pendant la planification de l`étude');
        }
      );
    };

    const saveMultiSiteStudies = (selectedSites, multiSiteState) => {
      $multiButton.addClass('loading');

      const requests = selectedSites.map(site => {
        const siteState = multiSiteState[site.id];

        // Serialize form
        const data = new FormData();

        data.append('sites', site.id);

        if (siteState && !siteState.workerUnknown && siteState.worker) {
          data.append('worker', siteState.worker);
        }
        if (siteState && !siteState.dateUnknown && siteState.date) {
          data.append('studyDate', siteState.date);
        }

        return CaseApi.scheduleStudy(id, data);
      });

      const hideModal = () => {
        onCancel();
        $multiButton.removeClass('loading');
      };

      // Schedule study
      Promise.all(requests).then(
        _ => {
          hideModal();
          success('Etude planifiée avec succès');
        },
        err => {
          console.log('Error attempting to schedule case study', err);
          hideModal();
          error('Une erreur est survenue pendant la planification de l`étude');
        }
      );
    };

    // Handling approve button
    const onApprove = state => () => {
      if (state && state.isMultiSchedule) {
        saveMultiSiteStudies(state.selectedSites, state.bySiteStudySchedule);
      } else if (state) {
        saveStudy(state.selectedSites, state.generalStudySchedule);
      }
    };

    // Display modal
    ReactDOM.render(
      <StudyModal
        sites={sites}
        workers={workers}
        onCancel={onCancel}
        onApprove={onApprove}
      />,
      root
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/study/index.js